















































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import MallConfig from '@/api/mall/mallConfig/index'
import CustomTable from '@/components/custom-table/index.vue'
import draggable from 'vuedraggable'
import CustomTableApi from '@/api/customTable/api'
@Component({
  components: {
    PicModal,
    draggable,
    CustomTable,
  },
})
export default class BasicSetting extends AbpBase {
  storeApi: string = CustomTableApi.storeApi
  storeFilters: any[] = [
    {
      label: '关键字搜索',
      type: 'input',
      props: {
        placeholder: '请输入店铺关键字',
      },
      key: 'KeyWord',
    },
  ]
  storeColumns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '名称',
      key: 'displayName',
      align: 'center',
    },
    {
      title: '编码',
      key: 'code',
      align: 'center',
    },
    // {
    //   title: '地址',
    //   key: 'detailAddress',
    //   align: 'center',
    // },
    {
      title: '是否启用',
      key: 'isActive',
      slot: 'isActive',
      align: 'center',
    },
  ]
  activeTab = 0
  tabList = ['常规设置', '购物设置', '优惠券样式设置', '导购设置']
  // 常规设置
  GeneralConfig = {
    MallImage: [],
    EntranceImage: '',
  }
  // 优惠券样式设置
  CouponStyleConfig = {
    backgroundImage: '',
    backgroundColor: '',
  }

  //购物设置
  ShoppingConfig = {
    AutoComfirmReceiptExpriedTime: null,
    // AutoCancelOrderExpriedTime: null,
    AutoArchiveExpriedTime: null,
    isOpenFutures: false
  }

  // 易神同步设置
  ysSyncConfig: any = {
    shopCodes: [],
    percentage: null,
  }

  validateAutoComfirm = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入自动确认收货时间'))
    }
    if (value <= 0) {
      callback(new Error('自动确认收货时间不能小于等于0'))
    } else {
      callback()
    }
  }

  validateAutoCancel = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入订单未支付取消时间'))
    }
    if (value <= 0) {
      callback(new Error('订单未支付取消时间不能小于等于0'))
    } else {
      callback()
    }
  }
  validateAutoArchive = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入自动归档订单时间'))
    }
    if (value <= 0) {
      callback(new Error('自动归档订单时间不能小于等于0'))
    } else {
      callback()
    }
  }
  ruleShoppingConfig = {
    AutoComfirmReceiptExpriedTime: [{ validator: this.validateAutoComfirm, trigger: 'blur' }],
    // AutoCancelOrderExpriedTime: [{ validator: this.validateAutoCancel, trigger: 'blur' }],
    AutoArchiveExpriedTime: [{ validator: this.validateAutoArchive, trigger: 'blur' }],
  }

  get selectPicNumber() {
    let num = 5
    let list = this.GeneralConfig.MallImage || []
    let len = num - list.length
    return len > 0 ? len : 0
  }

  //导购设置
  ShoppingGuideConfig = {
    DiyShareAudti: false,
  }

  created() {
    this.getConfig('ShoppingConfig')
    // this.getConfig('CouponStyleConfig')
    this.getSynsShopConfig()
  }
  picChange(e) {
    console.log(e)
    this.CouponStyleConfig.backgroundImage = e[0].url
  }
  /**
   * 选择图片
   */
  storePhotoChange(event) {
    let len = 5 - this.GeneralConfig.MallImage.length
    len = len > event.length ? event.length : len
    for (let i = 0; i < len; i++) {
      this.GeneralConfig.MallImage.push(event[i].url)
    }
  }

  EntranceImageChange(event) {
    this.GeneralConfig.EntranceImage = event[0].url
  }

  removeImg(index) {
    this.GeneralConfig.MallImage.splice(index, 1)
  }

  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then((res) => {
      if (res.data) {
        this[key] = res.data
      }
    })
  }

  // 获取同步库存设置
  getSynsShopConfig() {
    MallConfig.syncShopConfig('get').then((res) => {
      this.ysSyncConfig = res.data
    })
  }
  // 删除店铺标签
  handleClose(index) {
    this.ysSyncConfig.shopCodes.splice(index, 1)
  }
  // 易神同步设置提交
  ysSyncSettingSubmit() {
    if (!this.ysSyncConfig.shopCodes.length) {
      this.$Notice.warning({
        desc: '请先选择店铺',
      })
      return
    }
    if (!this.ysSyncConfig.percentage) {
      this.$Notice.warning({
        desc: '请输入同步库存百分比',
      })
      return
    }
    MallConfig.syncShopConfig('post', this.ysSyncConfig).then((res) => {
      this.$Notice.success({
        desc: '提交成功',
      })
      this.getSynsShopConfig()
    })
  }
  handleSelectCustomTable(e: any, type: string) {
    console.log(e, type)
    switch (type) {
      case 'store':
        let codeArr = e.map((item) => item.code)
        this.ysSyncConfig.shopCodes = Array.from(new Set(this.ysSyncConfig.shopCodes.concat(codeArr)))
        break
    }
  }

  /**
   * 常规设置提交
   */
  generalSubmit() {
    if (this.GeneralConfig.MallImage.length == 0) {
      this.$Modal.error({
        title: '请选择店铺形象照',
      })
      return
    }

    MallConfig.updateMallConfig('GeneralConfig', '常规设置', this.GeneralConfig).then((res) => {
      this.$Notice.success({
        desc: '提交成功',
      })
      this.getConfig('GeneralConfig')
    })
  }
  // 优惠券样式设置提交
  couponSubmit() {
    MallConfig.updateMallConfig('CouponStyleConfig', '优惠券样式设置', this.CouponStyleConfig).then((res) => {
      this.$Notice.success({
        desc: '提交成功',
      })
      this.getConfig('CouponStyleConfig')
    })
  }
  /**
   * 购物设置提交
   */
  shoppingConfigSubmit() {
    let vm = this
    let ShoppingConfig: any = vm.$refs.ShoppingConfig
    ShoppingConfig.validate((valid) => {
      if (valid) {
        vm.ShoppingConfig.AutoComfirmReceiptExpriedTime = Number(vm.ShoppingConfig.AutoComfirmReceiptExpriedTime)
        // vm.ShoppingConfig.AutoCancelOrderExpriedTime = Number(vm.ShoppingConfig.AutoCancelOrderExpriedTime)
        vm.ShoppingConfig.AutoArchiveExpriedTime = Number(vm.ShoppingConfig.AutoArchiveExpriedTime)
        MallConfig.updateMallConfig('ShoppingConfig', '购物设置', vm.ShoppingConfig).then((res) => {
          vm.$Notice.success({
            desc: '提交成功',
          })
          vm.getConfig('ShoppingConfig')
        })
      }
    })
  }

  /**
   * 导购设置提交
   */
  ShoppingGuideSubmit() {
    MallConfig.updateMallConfig('ShoppingGuideConfig', '导购设置', this.ShoppingGuideConfig).then((res) => {
      this.$Notice.success({
        desc: '提交成功',
      })
      this.getConfig('ShoppingGuideConfig')
    })
  }
}
